import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "utils/api";
import TeamShell from "./TeamShell";
import { formatLong } from "./formatters";

const StaffRejectBookingPage = () => {
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token") || "";
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) {
      setError("Ungültiger Link.");
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    api
      .get("/bookings/staff/reject", { params: { token } })
      .then(({ data }) => {
        if (!cancelled) setBooking(data.booking);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err?.response?.data?.message || "Link abgelaufen oder ungültig.");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmed = reason.trim();
    if (!trimmed) {
      setError("Bitte gib einen Grund für die Ablehnung an.");
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      await api.post("/bookings/staff/reject", { token, reason: trimmed });
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.message || "Ablehnung fehlgeschlagen.");
    } finally {
      setSubmitting(false);
    }
  };

  const customerName = booking
    ? `${booking.customer?.firstName || ""} ${booking.customer?.lastName || ""}`.trim()
    : "";

  return (
    <TeamShell>
      <section className="team-login">
        <div className="auth-card team-login-card" style={{ maxWidth: "32rem" }}>
          <p className="auth-kicker">Buchung ablehnen</p>
          <h1>Termin absagen</h1>

          {loading && <p className="auth-lead">Wird geladen…</p>}
          {error && !loading && <div className="auth-alert is-error">{error}</div>}

          {done && (
            <>
              <p className="auth-lead">
                Die Buchung wurde abgelehnt. Der Kunde wurde per E-Mail mit Ihrem
                Hinweis informiert.
              </p>
              <div className="auth-actions">
                <Link to="/admin-dashboard" className="auth-submit" style={{ textAlign: "center" }}>
                  Zum Admin-Dashboard
                </Link>
              </div>
            </>
          )}

          {!loading && !done && booking && (
            <>
              <p className="auth-lead">
                <strong>{booking.hoffmannBookingOption || booking.serviceLabel}</strong>
                <br />
                {customerName || "Kunde"} · {formatLong(booking.start)}
              </p>
              <form className="auth-form" onSubmit={handleSubmit}>
                <div>
                  <label htmlFor="staff-reject-reason">Grund für die Ablehnung *</label>
                  <textarea
                    id="staff-reject-reason"
                    rows={4}
                    maxLength={500}
                    required
                    value={reason}
                    disabled={submitting}
                    placeholder="z. B. Termin nicht verfügbar, PLZ außerhalb des Gebiets…"
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>
                <p style={{ fontSize: "0.85rem", color: "var(--grey-mid)" }}>
                  Der Kunde erhält diese Begründung in der Storno-E-Mail.
                </p>
                <div className="auth-actions">
                  <button type="submit" className="auth-submit" disabled={submitting}>
                    {submitting ? "Wird gesendet…" : "Ablehnung bestätigen"}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </section>
    </TeamShell>
  );
};

export default StaffRejectBookingPage;
